/**
 * Lead-submission API client.
 * POSTs estimate-form data to the backend, which emails it to the business
 * via Zoho SMTP. Returns { ok: true } on success or throws an Error.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export async function submitLead(payload, { source = "website" } = {}) {
  if (!BACKEND_URL) throw new Error("Backend URL not configured");
  const res = await fetch(`${BACKEND_URL}/api/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: payload.name?.trim() || "",
      phone: payload.phone?.trim() || "",
      email: payload.email?.trim() || "",
      address: payload.address?.trim() || "",
      service: payload.service?.trim() || "",
      details: payload.details?.trim() || "",
      source,
    }),
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      if (j && j.detail) detail = j.detail;
    } catch {
      /* ignore */
    }
    throw new Error(detail);
  }
  return res.json();
}
